// Polyfills
require('unfetch')

const React = require('react')
const Layout = require('./src/components/Layout').default
const Provider = require('./src/components/Provider').default
const createStore = require('./src/stores/AppStore').default
const app = require('magic-tricks/lib/getApp').default()
const routeDuration = require('./src/components/Layout').TRANSITION_DURATION

// Create store
app.store = createStore()

// Start firing side effects
app.store.hydratePassword()
app.store.hydrateTokenFromCache()

// Wrap every page with the main layout
exports.wrapPageElement = ({element, props}) => (
  <Layout {...props}>{element}</Layout>
)

// Wrap application with provider
exports.wrapRootElement = ({element, props}) => (
  <Provider {...props} store={app.store}>
    {element}
  </Provider>
)

// Delay updating scroll

exports.shouldUpdateScroll = ({prevRouterProps, routerProps}) => {
  if (!prevRouterProps) return
  if (routerProps.location.pathname !== prevRouterProps.location.pathname) {
    setTimeout(() => {
      window.scrollTo(0, 0)
    }, routeDuration)
  }

  return false
}
